import { render } from "./ACAMandateReports.vue?vue&type=template&id=6054ee1a&ts=true"
import script from "./ACAMandateReports.vue?vue&type=script&lang=ts"
export * from "./ACAMandateReports.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__